import { useCallback, useEffect, useRef, useState } from "react"
import { CircularProgressbarWithChildren } from "react-circular-progressbar"
import { useAudioPlayer } from "../customHooks/useAudioPlayer"
import '../styles/playerButton.css'

type PlayingState = 'play' | 'pause'

const ChatAudioPlayer = (props: { voiceUrl: string | undefined, callBack?: ()=>void }) => {

    //const ref = useRef<HTMLDivElement>(null)
    // const [isPlayingState, setIsPlaying] = useState<boolean>(false)
    // const [duration, setDuration] = useState<number>()
    // let audio = useRef<HTMLAudioElement>()
    // let isLoaded: boolean = false

    // const setAudioData = () => {
    //     setDuration(audio.current!.duration);
    //    // setCurTime(audio.currentTime);
    //   }

    // // useEffect(()=>{
    // //     let audio = audioRef.current

    // //     audio.addEventListener("loadedmetadata", setAudioData);


    // // })

    // const audioRef = useCallback((node: HTMLAudioElement)=>{

    //     if(node) {
    //         audio.current = node
    //         audio.current!.addEventListener("loadedmetadata", setAudioData);
    //         audio.current!.addEventListener('ended', ()=>setIsPlaying(false))
    //         //audio.addEventListener('loadeddata', playAudio)
    //     }

    // },[])

    // function playAudio(){

    //     audio.current?.play()
    //     setIsPlaying(true)
    // }

    // function pauseAudio(){

    //     audio.current?.pause()
    //     setIsPlaying(false)
    // }

    // function loadAudio(){
    //     if(isLoaded == false){
    //         audio.current?.load()
    //         isLoaded = true
    //     }
    //     else
    //      playAudio()

    // }

    const { audioRef, duration, isPlayingState, pauseAudio, playAudio, curTime } = useAudioPlayer()

    function handlePlay(e: React.MouseEvent<HTMLElement, MouseEvent>) {
        e.stopPropagation()
        playAudio()
        if(props.callBack)
         props.callBack()

    }

    function handlePause(e: React.MouseEvent<HTMLElement, MouseEvent>) {
        e.stopPropagation()
        pauseAudio()

    }

    console.log(curTime)



    return (
        <div style={{ height: 50, width: 50 }} >
            <CircularProgressbarWithChildren value={curTime/duration*100} >
                <div className='flex-row center-align' >
                    {/* <p>{Math.ceil(duration!)} sec</p> */}
                    <div className='player-button'>
                        <audio ref={audioRef} src={props.voiceUrl} preload='metadata' ></audio>
                        {
                            isPlayingState == true ?
                                <i className='material-icons' onClick={handlePause} >pause</i> :
                                <i className='material-icons' onClick={handlePlay} >play_arrow</i>

                        }

                    </div>
                </div>
            </CircularProgressbarWithChildren>
        </div>
    )

}

export default ChatAudioPlayer